import { RouterProvider } from 'react-router-dom';
import { LazyMotion, domAnimation } from 'framer-motion';
import { router } from '@/app/router';
import { Toaster } from '@/components/system/Toaster';
import { ErrorBoundary } from '@/components/system/ErrorBoundary';

// 2-nov (react-best-practices, bundle): fuera @tanstack/react-query — estaba
// montado pero ningún componente lo usaba (las lecturas van por useLoad).
export default function App() {
  return (
    <ErrorBoundary>
      {/* 2-nov (bundle): componentes `m` + LazyMotion con domAnimation (sin el
          motor de layout). `strict` impide volver a importar `motion`. */}
      <LazyMotion features={domAnimation} strict>
        <RouterProvider router={router} />
        {/* Global: los toasts deben verse también fuera del shell (p. ej. /login). */}
        <Toaster />
      </LazyMotion>
    </ErrorBoundary>
  );
}
